// extracted by mini-css-extract-plugin
export default {"skeleton-list":"RX4m5","skeleton-item":"HdAl6","column-4":"Yce7Q","column-3":"eyKZq","column-5":"FJGmP"};